import type { RootState } from 'state';
import type { RoutesFiltersState } from '../slice';

function getStops(state: RootState): RoutesFiltersState['stops'] {
  const { stops } = state.flightRoutes.filtersValues;
  return stops;
}

export default getStops;
